import { URLs } from "../Utility/Constants";
import { apiRequest } from "./ApiUtility";
import axios from "./axios";

export async function getPrimaryClinicalServices(authContext) {
  const url = `/api/facilitysettings/primaryandactiveclinicalservice/${authContext?.selectedFacility?.id}`;
  return await apiRequest("get", url, authContext);
}

export async function getClinicalServices(authContext, filters) {
  const url = "/api/facilitysettings/clinicalservices/get";
  const data = {
    facilityId: authContext?.selectedFacility?.id,
    visitType: filters?.visitType,
  };
  return await apiRequest("post", url, authContext, data);
}

export async function createClinicalService(authContext, clinicalService) {
  const url = URLs.ClinicalServiceAPI;
  const data = {
    name: clinicalService.name,
    facilityId: clinicalService.facilityId,
    durationInMins: clinicalService.durationInMins,
    description: clinicalService.description,
    isActive: clinicalService.isActive,
    fees: clinicalService.fees,
    schedulingByPatient: clinicalService.schedulingByPatient,
    allowedLocations: clinicalService.allowedLocations
  };
  return await apiRequest("post", url, authContext, data);
}

export async function updateClinicalService(authContext, clinicalService) {
  const url = `${URLs.ClinicalServiceAPI}/${clinicalService.id}`;
  const data = {
    name: clinicalService.name,
    facilityId: clinicalService.facilityId,
    durationInMins: clinicalService.durationInMins,
    description: clinicalService.description,
    isActive: clinicalService.isActive,
    fees: clinicalService.fees,
    schedulingByPatient: clinicalService.schedulingByPatient,
    allowedLocations: clinicalService.allowedLocations,
  };
  return await apiRequest("put", url, authContext, data);
}

export async function removeClinicalService(authContext, clinicalServiceId) {
  const url = `${URLs.ClinicalServiceAPI}/${clinicalServiceId}`;
  
  // Custom handling for delete operation with errorMessage field
  const result = { isSuccess: false, data: {}, errorMessage: "" };
  
  if (!authContext) {
    result.errorMessage = "Authentication context is missing";
    return result;
  }

  try {
    const response = await axios({
      method: "delete",
      url,
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.errorMessage = error?.response;
  }

  return result;
}

export async function getFacilityDetails(authContext) {
  const url = `/api/facility/${authContext?.auth?.selectedFacility?.id}`;
  
  // Note: Using authContext.auth.authToken as in original code
  const modifiedAuthContext = {
    ...authContext,
    authToken: authContext?.auth?.authToken
  };
  
  return await apiRequest("get", url, modifiedAuthContext);
}

export async function updateFacility(authContext, facility) {
  const url = `/api/facility/${authContext?.selectedFacility?.id}`;
  const data = {
    name: facility?.name,
    email: facility?.emailId,
    mobileNo: facility?.mobileNo,
    isActive: true,
    logo: facility?.logo,
    addressLine1: facility?.addressLine1,
    addressLine2: facility?.addressLine2,
    pin: facility?.addressPIN,
    state: facility?.addressState,
    city: facility?.addressCity,
    // Add license details with proper structure
    licenseDetails: {
      allowedPrescriptions: facility?.licenseDetails?.allowedPrescriptions || []
    }
  };
  
  // Log facility data as in original code
  console.log(JSON.stringify(facility));
  
  return await apiRequest("put", url, authContext, data);
}

